import { FC } from 'react'
import { PremiumMembershipNo } from '@lib/membership-types'

type MembershipDiamondProps = {
  membershipNo?: PremiumMembershipNo | 99
  size?: number
  className?: string
}

const colors = {
  4: '#093C62',
  3: '#AB7C08',
  2: '#656F74',
  1: '#2D4353',
  99: '#909090',
}

export const MembershipDiamond: FC<MembershipDiamondProps> = ({
  size = 32,
  className,
  // default value for showing a diamond without a membership color
  membershipNo = 99,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
      style={{
        color: colors[membershipNo],
        strokeWidth: 0.5,
      }}
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M22.474 13.074l-6.453 17.93a.737.737 0 00.569-.26l14.652-17.642-.02-.028h-8.748z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M31.224 13.077L25.342 3.6l-2.867 9.477h8.749zM6.704 3.6L.822 13.077h8.75L6.703 3.6z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M.82 13.074l-.02.028 14.653 17.643a.738.738 0 00.568.259l-6.452-17.93H.819z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M16.02 3.6H6.7l2.867 9.477L16.019 3.6z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M9.563 13.074l6.452 17.93 6.452-17.93H9.563zM25.342 3.6h-9.32l6.452 9.477L25.342 3.6z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M22.467 13.077L16.015 3.6l-6.453 9.477h12.905z"
      ></path>
    </svg>
  )
}
